import CryptoJS from "crypto-js";
import { cryptoSecretKey } from "./Constant";

const key = CryptoJS.enc.Utf8.parse(cryptoSecretKey);

export const encryptId = (id) => {
  const encrypted = CryptoJS.AES.encrypt(id, key, {
    mode: CryptoJS.mode.ECB,
  }).toString();
  return encrypted.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, ""); // URL-safe
};

export const decryptId = (encryptedId) => {
  const restored = encryptedId.replace(/-/g, "+").replace(/_/g, "/"); // Convert back
  return CryptoJS.AES.decrypt(restored, key, {
    mode: CryptoJS.mode.ECB,
  }).toString(CryptoJS.enc.Utf8);
};
